import { Placement } from "./Placement";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";

export class SwitchButtonPlacement extends Placement {
  switchesWallsOnCollide(forBody) {
    if (forBody.isImmuneToWallSwitch) {
      return false;
    }
    return true;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.PURPLE_BUTTON} />;
  }
}
